import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import {
  dialogOnlyStore,
  SBDialogContainer,
} from '@smart-builder/components/src/dialog';
import { SBAppContainer } from '@smart-builder/rest-components/src/SBAppContainer';
// using direct imports here to reduce the built size of login-rest as much as possible
import { SBLogger } from '@smart-builder/util/src/SBLogger';
import App from './App';
import './index.scss';

SBLogger.init();

const store = dialogOnlyStore();

const container = document.getElementById('root-div');
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <SBDialogContainer />
    <SBAppContainer appName="login-rest">
      <App />
    </SBAppContainer>
  </Provider>,
);
